import React, { useState } from 'react';
import { TwitterIcon, HeartIcon, CommentIcon, RetweetIcon, SpinnerIcon } from '../icons'
import photo from '../../assets/Z2.jpg'

function decodeUnicode(str) {
    try {
        return JSON.parse(`"${str}"`);
    } catch {
        return str;
    }
  }
  

const TweetCard = ({ targetUrl, formattedDate, nLikes, nComments }) => {

    const [input, setInput] = useState("")
    const [result, setResult] = useState("")

    const [status, setStatus] = useState("idle") // status = { "idle", "loading", "done", "error" }

    const showError = (message) => {
        setResult(message)
        setStatus("error")
    }

    const handleApiCall = async () => {
        setResult(input)
        setStatus("loading")

        if (input.length === 0){
            showError("Error: Cannot send empty data.")
            return
        }

        // The model echoes the input back: skip that many words from the stream
        const nWords = input.split(/[\n\t ]+/).length

        try {
            const response = await fetch(targetUrl, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ input_text: input })
            })

            if (!response.ok){
                showError(response.status === 403
                    ? "Error: Request limit reached 🌚."
                    : "Error: something went wrong with Cloudflare 💀.")
                return
            }

            // Read stream SSE
            const reader = response.body.getReader()
            const decoder = new TextDecoder("utf-8")
            let idx = 0

            while(true){
                const {done, value} = await reader.read()
                if (done) break;
                const chunk = decoder.decode(value, {stream: true}).split('data: ["')[1]
                // SSE arrives with new lines
                const words = chunk.split(/[\n\t ]+/)
                for(let word of words){
                    if (word.endsWith('"]')){
                        word = word.replace('"]', "").trim()
                    }
                    word = decodeUnicode(word).replace("\ufffd", "").replace("\n", " ")

                    if (idx < nWords){
                        idx++
                        continue
                    }

                    await new Promise(r => setTimeout(r, 150))
                    setResult((prev) => prev.trim() + " " + word)
                }
            }

            setResult((prev) => prev.trim() + ".")
            setStatus("done")
        } catch {
            showError("Error: something went wrong 💀.")
        }
    }

    return (
        <div className="w-full shadow bg-white dark:bg-gray-800 border-gray-200 dark:border-gray-800 p-4 rounded-xl sm:rounded-2xl border">
            <div className="flex justify-between">
            <div className="flex items-center">
                <img className="size-11 xl:size-16 2xl:size-20 rounded-full" src={photo} alt="Profile"/>
                <div className="ml-2 text-xs xl:text-base 2xl:text-xl leading-tight">
                    <span className="font-bold block text-black dark:text-white">Alessandro David</span>
                    <span className="font-normal block text-gray-500 dark:text-gray-400">@botalepower</span>
                </div>
            </div>
            <TwitterIcon className="h-6 xl:h-8 2xl:h-10 w-auto inline-block fill-current text-blue-400 dark:text-white" />
            </div>
            { status === "idle" && <textarea 
                className="bg-transparent w-full resize-none text-black dark:text-white block text-base xl:text-xl 2xl:text-2xl leading-snug mt-3 sm:h-[3ch]" 
                maxLength="30"
                placeholder="Type something here to generate a tweet!"
                value={input}
                onChange={(e) => setInput(e.target.value)}

            />}
            { status !== "idle" && <div className={`bg-transparent w-full resize-none ${ status === "error" ? "text-red-600" : "text-black dark:text-white"} block text-base xl:text-xl 2xl:text-2xl leading-snug mt-3`} > 
                {result} 
                </div>
            }
            <p className="text-xs xl:text-base 2xl:text-lg text-gray-500 dark:text-gray-400 py-1 my-0.5">{formattedDate}</p>
            <div className="border-gray-200 dark:border-gray-600 border border-b-0 my-1"></div>
            
            <div className="text-gray-500 dark:text-gray-400 flex justify-between mt-3">
                
                <div className='flex'> 
                    <div className="flex items-center mr-4 xl:mr-6 2xl:mr-10">
                        <HeartIcon className="fill-current size-5 xl:size-7 2xl:size-9" />
                        <span className="text-xs xl:text-lg ml-2 2xl:ml-4">{nLikes}</span>
                    </div>

                    <div className="flex items-center mr-6">
                        <CommentIcon className="fill-current size-5 xl:size-7 2xl:size-9" />
                        <span className="text-xs xl:text-lg ml-2 2xl:ml-4">{nComments}</span>
                    </div>
                </div>

                <div className="flex justify-self-end items-center">
                    { status === "idle" && <button onClick={handleApiCall}>
                        <RetweetIcon className="fill-current size-5 xl:size-7 2xl:size-9" />
                    </button>}
                </div>
                { status === "loading" && <SpinnerIcon className="w-8 h-8 text-blue-500 animate-spin" />}

            </div>
        </div>
    )
}

// Picked once per visit: stay the same across re-renders and page changes
const SESSION_LIKES = Math.floor(Math.random() * (10 - 1 + 1)) + 0;
const SESSION_COMMENTS = Math.floor(Math.random() * (5 - 1 + 1)) + 0;

export const Tweet = ({ currentDate, targetUrl }) => {
    // Example POST body {"input_text": "no cap"}
    // e.g. "14:05 · Oct 3, 2026"
    const time = currentDate.toLocaleTimeString('en-US', { hour: 'numeric', minute: 'numeric', hourCycle: 'h23' })
    const date = currentDate.toLocaleDateString('en-US', { day: 'numeric', month: 'short', year: 'numeric' })
    const formattedDate = `${time} · ${date}`

    return (
    <div>
        <TweetCard targetUrl={targetUrl} formattedDate={formattedDate} nLikes={SESSION_LIKES} nComments={SESSION_COMMENTS}/>
    </div>
  )
}
